<template>
  <div id="ultra-frame" :style="`background-color:${bg}`">
    <div id="ultra-container">
      <!-- HEADER -->
      <SubpageHeader
        :is_sticky="true"
        :is_create_screen="is_new_step"
        :background_color="bg"
        :foreground_color="fg"
        @backBtnClicked="test('back')"
        @saveBtnClicked="test('save')"
        @cancelBtnClicked="test('cancel')"
      >
        <template #rightside>
          <div v-if="!is_new_step" class="work-package-step-detail-header">
            <!-- STEP TYPE -->
            <!-- <div class="work-package-step-detail-type">
              <v-icon :color="fg">
                {{ getStepIcon(step.type) }}
              </v-icon>
              <TText
                :text="step.type.toUpperCase() + '.step'"
                medium
                :color="fg"
              />
            </div> -->

            <!-- CHECKBOX -->
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <div
                  class="work-package-step-detail-checkbox"
                  v-bind="attrs"
                  v-on="on"
                >
                  <RadialCheckbox
                    :id="step.id"
                    :is_checked="step.done"
                    large
                    :background_color="bg"
                    :foreground_color="fg"
                    @setActive="setActive()"
                  />
                </div>
              </template>
              <span>{{ step.done ? 'Set to open' : 'Set to done'}}</span>
            </v-tooltip>

            <!-- OPTIONS TOGGLE -->
            <v-btn icon @click="turnOnOptionsDisplay">
              <v-icon :color="fg">
                mdi-dots-vertical
              </v-icon>
            </v-btn>

            <!-- ACTUAL OPTIONS -->
            <TransitionAccordion>
              <PopUpOverlay
                v-if="show_options"
                :width="`140px`"
                :margin="8"
                :position_css="`
                  bottom: 34px; /* below-slot-height (24px) + spacing-bottom (10px) */
                  right: 0;
                  transform: translate(0%, 100%);
                `"
                :is_no_cancel="true"
                @closeOverlay="turnOffOptionsDisplay"
              >
                <template #body>
                  <div class="work-package-step-detail-option-buttons">
                    <ClickablePopUpIcon
                      v-for="(option, index) in options"
                      :key="`option-display${index}`"
                      :icon="option.icon"
                      :icon_color="full_color/* TODO: should be primary */"
                      :description="option.description"
                      :description_color="full_color/* TODO: should be primary */"
                      @selected="selectOption(option)"
                    />
                  </div>
                </template>
              </PopUpOverlay>
            </TransitionAccordion>
          </div>
        </template>
      </SubpageHeader>

      <!-- ACTUAL CONTENT -->
      <div class="work-package-step-detail-container">


        <LabelOutlined
          :label="`${step.type.toUpperCase()}.step status`"
          :background_color="bg"
          :dark="is_light_mode(fg)"
        >
          <template #content>
            <div class="work-package-step-detail-status-container">
              <ButtonOutlined
                class="work-package-step-detail-status-button"
                :style="`background-color: ${step.done ? bg : fg};`"
                icon="checkbox-radial-empty"
                text="Open"
                :color="step.done ? fg : bg"
                @buttonClicked="setActive(false)"
              />
              <ButtonOutlined
                class="work-package-step-detail-status-button"
                :style="`background-color: ${step.done ? fg : bg};`"
                icon="checkbox-radial-filled"
                text="Done"
                :color="step.done ? bg : fg"
                @buttonClicked="setActive(true)"
              />
            </div>
          </template>
        </LabelOutlined>
        <TextArea
          :text="step.text"
          :label="`Description`"
          :placeholder="`Describe the ${step.type.toUpperCase()}.step...`"
          :max_char_count="is_edit ? 300 : ''"
          :height="170"
          :background_color="bg"
          :foreground_color="fg"
          :is_disabled="!is_edit"
        />

        <div class="work-package-step-detail-total-effort">
          <v-icon :color="fg">
            mdi-sigma
          </v-icon>
          <v-icon small :color="fg">
            mdi-speedometer
          </v-icon>
          <TText
            class="work-package-step-detail-total-effort-text"
            :text="`Total: ${some_value} mh`"
            small
            :color="fg"
          />
        </div>

        <div class="work-package-step-detail-equation">
          <ModularEquation
            description="Aufwandswerte (Englisch!)"
            :elements="[
              { label: 'Time effort', /*width: 85,*/ value: '0', is_disabled: !is_edit},
              { operator: 'mh /'},
              { label: 'Reference unit', width: 130, select: {
                  options: [
                    'lateral-surface', 'perimeter', 'floor-area',
                    'ceiling-area', 'volume', 'height', 'length',
                    'width', 'weight', 'side-area', 'count',
                    'absolute', 'surface',
                  ],
                },
              },
            ]"
            :background_color="bg"
            :foreground_color="fg"
            @selected="test($event)"
          />
        </div>

        <div class="work-package-step-detail-equation">
          <ModularEquation
            description="Materialstep Detail (Englisch!)"
            :elements="[
              { label: 'Factor', /*width: 85,*/ value: '0', is_disabled: !is_edit },
              { label: 'Unit', width: 80, is_disabled: !is_edit, select: {
                  options: [
                    'meter', 'liter', 'units',
                  ],
                },
              },
              { operator: '/'},
              { label: 'Reference unit', width: 130, select: {
                  options: [
                    'lateral-surface', 'perimeter', 'floor-area',
                    'ceiling-area', 'volume', 'height', 'length',
                    'width', 'weight', 'side-area', 'count',
                    'absolute', 'surface',
                  ],
                },
              },
            ]"
            :background_color="bg"
            :foreground_color="fg"
            @selected="test($event)"
          />
        </div>

        <!-- IMAGE TILES -->
        <CollapsableImagesCategory
          :images="step.images"
          :background_color="bg"
          :foreground_color="fg"
          @emittedClick="test($event)"
        />
      </div>
    </div>
  </div>
</template>

<script>
import RadialCheckbox from '@/components/WorkPackageWIP/RadialCheckbox.component.vue';
import TextArea from '@/components/WorkPackageWIP/TextArea.component.vue';
import TText from '@/components/Taktify/TText.component.vue';
import SubpageHeader from '@/modules/WorkPackageWIP/SubpageHeader.module.vue';
import ModularEquation from '@/modules/WorkPackageWIP/ModularEquation.module.vue';
import PopUpOverlay from '@/components/WorkPackageWIP/PopUpOverlay.component.vue';
import ClickablePopUpIcon from '@/components/WorkPackageWIP/ClickablePopUpIcon.component.vue';
import TransitionAccordion from '@/components/WorkPackageWIP/TransitionAccordion.component.vue';
import LabelOutlined from '@/components/WorkPackageWIP/LabelOutlined.component.vue';
import ButtonOutlined from '@/components/WorkPackageWIP/ButtonOutlined.component.vue';
import CollapsableImagesCategory from '@/modules/WorkPackageWIP/CollapsableImagesCategory.module.vue';
import { WorkPackageWIPMixin } from '@/mixins/WorkPackageWIPMixin.mixin.js';
import { TColor } from '@/mixins/TColor.mixin.js';

  export default {
    components: {
      RadialCheckbox,
      TextArea,
      TText,
      SubpageHeader,
      ModularEquation,
      PopUpOverlay,
      ClickablePopUpIcon,
      TransitionAccordion,
      LabelOutlined,
      ButtonOutlined,
      CollapsableImagesCategory,
    },

    mixins: [
      WorkPackageWIPMixin,
      TColor,
    ],

    computed: {
      full_color() {
        return this.getColor();
      },
    },

    data: () => ({
      bg: '#FFC900',
      fg: '#000',
      // bg: '#330011',
      // fg: '#FFF',

      is_edit: true,
      is_new_step: false,
      some_value: 4123.64,
      show_options: false,
      time_effort: [
        { selected: 'volume', id: 0 }, // ref_unit
      ],
      material_step_detail: [
        { selected: 'unit', id: 1 }, // unit
        { selected: 'volume', id: 2 }, // ref_unit
      ],

      step: {
        id: 0,
        text: 'Unterputzdosen setzen',
        type: 'work',
        done: false,
        tworkpackageimages: [1, 2, 3, 4, 5, 6, 7, ],
        elements: [1, 2, 3, 4, ],
        material_step_count: 3,
        images: [
          {
            id: 0,
            image: 'https://images.pexels.com/photos/10154570/pexels-photo-10154570.jpeg?auto=compress&cs=tinysrgb&h=750&w=1260',
            description: 'Wüste',
            step: 'WORK.step',
            date: '2021-09-13 10:07:27 UTC',
            pers: { first_name: 'Marco', last_name: 'Herold' },
          },
          {
            id: 1,
            image: 'https://images.pexels.com/photos/2662116/pexels-photo-2662116.jpeg?auto=compress&cs=tinysrgb&h=750&w=1260',
            description: 'Bergsee',
            step: 'WORK.step',
            date: '2021-10-22 10:07:27 UTC',
            pers: { first_name: 'Timo', last_name: 'Vogelsang' },
          },
          {
            id: 2,
            image: 'https://images.pexels.com/photos/1591373/pexels-photo-1591373.jpeg?auto=compress&cs=tinysrgb&h=750&w=1260',
            description: 'Strand',
            step: 'WORK.step',
            date: '2021-11-22 10:05:27 UTC',
            pers: { first_name: 'Klaus', last_name: 'Schreier' },
          },
          {
            id: 3,
            image: 'https://images.pexels.com/photos/440731/pexels-photo-440731.jpeg?auto=compress&cs=tinysrgb&h=750&w=1260',
            description: 'Wiese',
            step: 'WORK.step',
            date: '2021-12-13 10:07:27 UTC',
            pers: { first_name: 'Florian', last_name: 'Genz' },
          },
          {
            id: 4,
            image: 'https://images.pexels.com/photos/417173/pexels-photo-417173.jpeg?auto=compress&cs=tinysrgb&h=650&w=940',
            description: 'Berg',
            step: 'WORK.step',
            date: '2021-12-13 09:07:27 UTC',
            pers: { first_name: 'Jürgen', last_name: 'Pape' },
          },
          {
            id: 5,
            image: 'https://images.pexels.com/photos/1036657/pexels-photo-1036657.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=750&w=1260',
            description: 'Stadt',
            step: 'WORK.step',
            date: '2022-01-13 09:07:27 UTC',
            pers: { first_name: 'Jürgen', last_name: 'Pape' },
          },
        ],
      },

      options: [
        { description: 'Copy', icon: 'mdi-content-copy'},
        { description: 'Delete', icon: 'mdi-delete'},
      ]
    }),

    methods: {
      setActive(active) {
        if(active !== undefined) {
          this.step.done = active;
        }
        else {
          this.step.done = !this.step.done;
        }
      },

      turnOnOptionsDisplay() {
        this.show_options = true;
      },

      turnOffOptionsDisplay() {
        this.show_options = false;
      },

      selectOption(option) {
        switch (option.description.toLowerCase()) {
          case 'delete':
            // TODO: mutate delete
            this.test('delete triggered');
            this.turnOffOptionsDisplay();
            break;
          case 'copy':
            // TODO: copy this step
            this.test('copy triggered');
            this.turnOffOptionsDisplay();
            break;
          default:
            break;
        }
      },
    },
  }
</script>

<style>
  #ultra-frame {
    width: 100%;
    height: calc(100% - 48px) !important;
  }
  #ultra-container {
    margin: 10px;
    margin-top: 0;
  }
  .work-package-step-detail-header {
    display: flex;
    align-items: center;
    /* height: 36px; */
  }
  .work-package-step-detail-type {
    display: flex;
    grid-gap: 8px;
    margin: 0 8px;
  }
  .work-package-step-detail-checkbox {
    display: flex;
    justify-content: center;
    /* align-items: center; */
    height: 36px;
    width: 36px;
    margin: 0 8px;
  }
  .work-package-step-detail-option-buttons {
    display: flex;
    flex-wrap: wrap;
    height: auto;
    width: 100%;
    align-items: center;
    grid-gap: 8px;
    padding: 16px;
    justify-content: space-between;
  }
  .work-package-step-detail-head-spacer {
    margin-top: 10px; /* 10px from frame */
  }
  .work-package-step-detail-container {
    display: flex;
    flex-direction: column;
    grid-gap: 8px;
  }
  .work-package-step-detail-status-container {
    display: flex;
    grid-gap: 8px;
    width: 100%;
  }
  .work-package-step-detail-status-button {
    flex-grow: 1;
  }
  .work-package-step-detail-equation {
    display: flex;
    align-items: center;
  }
  .work-package-step-detail-total-effort {
    display: flex;
    align-items: center;
    justify-content: flex-end;
  }
  .work-package-step-detail-total-effort-text {
    margin-left: 4px;
  }
</style>
